import type { DataPoint } from '@/components/DateTotalsGraph/types'
import createAgentApiService from '@/lib/agentApiServices/service'
import type { TransformedDateTotalActivitiesData } from '@/lib/apollo/query/getTotalActivitiesByDateForUser'
import { downloadBlob } from '@/utils/blob'
import { formatDate, yyyyMMddHHmm } from '@/utils/date'

export const getCsvFileName = (email: string, startDate: Date, endDate: Date) =>
  `${email}-completed-${formatDate(startDate, yyyyMMddHHmm)}-${formatDate(
    endDate,
    yyyyMMddHHmm,
  )}.csv`

type GetCompletedActivitiesForUserCsvArgs = {
  customerId: string
  userId: string
  email: string
  startDate: Date
  endDate: Date
  token: string
  accessKey: string
}

export const getCompletedActivitiesForUserCsv = async ({
  startDate,
  endDate,
  userId,
  email,
  customerId,
  token,
  accessKey,
}: GetCompletedActivitiesForUserCsvArgs): Promise<void> => {
  const agentService = createAgentApiService(token, accessKey)

  const blob = await agentService.getCompletedActivitiesForUserCsv({
    startDate,
    endDate,
    userId,
    customerId,
  })

  downloadBlob(getCsvFileName(email, startDate, endDate), blob)

  return Promise.resolve()
}

export const toDateTotalsGraphDataPoint = (
  data: TransformedDateTotalActivitiesData,
): DataPoint => ({
  ...data,
  total: data.totalActivities,
})
